<!-- 设备分组 -->
<template>
  <div class="container">
    <div class="containerBox">
      <div class="handle-box">
        <div class="fr">
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addGroup"
            v-has="'device_control'"
          >新增组别</el-button>
        </div>
      </div>
      <el-table
        :data="groupList"
        border
        class="table"
        ref="multipleTable"
      >
		<el-table-column
		type="index"
		width="100"
		label="序号"
		sortable
		align='center'
		>
		</el-table-column>
        <el-table-column
          prop="oid"
          label="编号"
          width="100"
        >
        </el-table-column>
        <el-table-column
          prop="groupname"
          label="名称"
          width="120"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="描叙"
          width="180"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="operator"
          label="操作员"
          width="120"
        >
        </el-table-column> -->
        <el-table-column
          prop="update_date"
          label="更新时间"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
               v-has="'device_control'"
              @click="handleEdit(scope.$index, scope.row)"
            >修改</el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              class="red"
               v-has="'device_control'"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
            <el-button
              type="text"
              icon="el-icon-plus"
              class="red"
               v-has="'device_control'"
              @click="handleAddDevice(scope.$index, scope.row)"
            >添加设备</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 编辑弹出框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="editVisible"
      width="40%"
    >

      <el-form
        ref="groupForm"
        :model="addForm"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item
          label="组别名称"
          prop="groupname"
        >
          <el-input v-model="addForm.groupname"></el-input>
        </el-form-item>
        <el-form-item
          label="控制设备类型"
          prop="grouptype"
        >
            <el-select v-model="addForm.devtype" clearable placeholder="请选择设备类型" :disabled="isedit">
                <el-option label="风盘" :value="1"></el-option>
                <el-option label="风柜" :value="2"></el-option>
            </el-select>
            <el-tooltip class="item" effect="dark" content="代表该分组里面只包含所选设备类型" placement="top">
                <i style="margin-left:15px;" class="el-icon-question"></i>
            </el-tooltip>
        </el-form-item>
        <el-form-item
          label="组别说明"
          prop="description"
        >
          <el-input v-model="addForm.description"></el-input>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="editVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="saveEdit"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
export default {
    name: "equipmentgroup",
    inject: ["reload"],
    data() {
        return {
			isedit:false,
            groupList: [],
            editVisible: false,
            dialogTitle: "添加组别",
            addForm: {
                groupname: '',
				devtype:'',
				description:''
            },
            rules: {
                groupname: [{required: true,message: "请输入组别名称",trigger: "blur"}]
            },
            
        };
    },
    
    created() {
        this.getMeterGroupList();
    },
    methods: {
        //  获取分组列表
        async getMeterGroupList() {
            let data = await Service.getMeterGroupList();
            if(data) {
                data = data === 'success' ? [] : data;
                this.groupList = data;
            }  
        },
        //  编辑组别
        handleEdit(index, row) {
			console.log(row)
            let {oid, groupname, description, devtype} = row;
            this.addForm.oid = oid;
            this.addForm.groupname = groupname;
            this.addForm.description = description;
            this.addForm.devtype = devtype == 0 ? "" : devtype
            this.dialogTitle = "编辑组别";
            this.editVisible = true;
			this.isedit = true
        },
        //  新增组别
        addGroup() {
            this.dialogTitle = "编辑组别"
            this.addForm = {
                groupname: ''
            }
            this.editVisible = true;
			this.isedit = false
        },
        //  编辑、新增 保存按钮
        saveEdit() {
            this.$refs["groupForm"].validate(async (valid) => {
                if (valid) {
                    let data
                    if(this.addForm.oid) {
                        // 修改
                        data = await Service.editMeterGroup(this.addForm);
                    }else{
                        // 新增
                        data = await Service.addMeterGroup(this.addForm);
                    }
                    if(data) {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.editVisible = false;
                        this.reload();
                    }
                } else {
                    return false;
                }
            });
        },
        //  删除组别
        handleDelete(index, row) {
            $Alert(`是否确认删除此 ${row.groupname}`).then(async (bool) => {
                if(bool) {
                    let data = await Service.deleteMeterGroup({OID: row.oid})
                    if(data) {
                        this.$message({
                            type: 'success',
                            message: `删除成功`
                        });
                        this.reload();
                    }
                }
            })
        },
        // 添加设备
        handleAddDevice(index, row) {
            this.$router.push(`/equipment/addmeter/${row.oid}`)
        },
    }
};
</script>
<style lang='css' scoped>
</style>
<style>
body .el-table::before {
    z-index: inherit;
}
</style>
